import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { AppData, StepInfo } from '../../models/applicationConnection'

type StepWrapperProps = {
  appData: AppData
  stepInfo: StepInfo
  children: ReactNode
  accountName?: string
}

export function StepWrapper({
  appData,
  stepInfo,
  children,
  accountName,
}: StepWrapperProps) {
  const { t } = useTranslation('common')

  const displayAccountName = accountName || appData.accountName

  return (
    <div className="flex justify-between w-full max-w-[90%] flex-col h-[350px]">
      <div className="flex flex-row justify-between">
        <div>
          <p className="font-semibold">
            {t('step_wrapper.application_label')} {appData.applicationName}
            {displayAccountName &&
              displayAccountName.trim() &&
              ` (${displayAccountName.trim()})`}
          </p>
        </div>
        {stepInfo.current > 0 && (
          <div className="text-sm text-gray-500">
            {t('step_wrapper.step_counter', {
              current: stepInfo.current,
              total: stepInfo.total,
            })}
          </div>
        )}
      </div>
      <div className="h-[300px] justify-center gap-5 flex flex-col">
        {children}
      </div>
    </div>
  )
}
